<main class="admin-shell">
  <section class="admin-container">
    <header class="admin-header">
      <div>
        <p class="eyebrow">{{ 'common.ssoBrand' | translate }}</p>
        <h1>{{ (isAdminView ? 'authLogs.adminTitle' : 'authLogs.myTitle') | translate }}</h1>
        <p class="subtitle">
          {{ (isAdminView ? 'authLogs.adminSubtitle' : 'authLogs.mySubtitle') | translate }}
        </p>
      </div>
      <a nz-button routerLink="/main">{{ 'common.backToModules' | translate }}</a>
    </header>

    @if (errorMessage) {
      <nz-alert nzType="error" [nzMessage]="errorMessage" nzShowIcon></nz-alert>
    }

    <nz-card>
      <form class="filters" (submit)="$event.preventDefault(); applyFilters()">
        @if (isAdminView) {
          <label>
            <span>{{ 'authLogs.loginFilter' | translate }}</span>
            <input nz-input [formControl]="login" [placeholder]="'authLogs.loginPlaceholder' | translate">
          </label>
        }

        <label>
          <span>{{ 'authLogs.event' | translate }}</span>
          <nz-select [formControl]="eventType" nzAllowClear [nzPlaceHolder]="'authLogs.allEvents' | translate">
            <nz-option [nzValue]="1" [nzLabel]="'authLogs.loginSuccess' | translate"></nz-option>
            <nz-option [nzValue]="2" [nzLabel]="'authLogs.loginFailed' | translate"></nz-option>
            <nz-option [nzValue]="3" [nzLabel]="'authLogs.logoutEvent' | translate"></nz-option>
          </nz-select>
        </label>

        <div class="filter-actions">
          <button nz-button nzType="primary" type="submit" [nzLoading]="isLoading">{{ 'common.find' | translate }}</button>
          <button nz-button type="button" (click)="resetFilters()">{{ 'common.resetFilters' | translate }}</button>
        </div>
      </form>

      <nz-table
        [nzData]="rows"
        [nzLoading]="isLoading"
        [nzShowPagination]="false"
        nzSize="middle"
        [nzNoResult]="'authLogs.empty' | translate"
      >
        <thead>
        <tr>
          <th>{{ 'authLogs.colDate' | translate }}</th>
          @if (isAdminView) {
            <th>{{ 'authLogs.colLogin' | translate }}</th>
          }
          <th>{{ 'authLogs.colEvent' | translate }}</th>
          <th>{{ 'authLogs.colReason' | translate }}</th>
          <th>{{ 'authLogs.colClient' | translate }}</th>
          <th>{{ 'authLogs.colIp' | translate }}</th>
          <th>{{ 'authLogs.colDevice' | translate }}</th>
        </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.id) {
            <tr>
              <td>{{ row.createdAt | date: 'dd.MM.yyyy HH:mm:ss' }}</td>
              @if (isAdminView) {
                <td>{{ row.login ?? '—' }}</td>
              }
              <td>
                <nz-tag [nzColor]="eventColor(row.eventType)">{{ eventLabel(row.eventType) }}</nz-tag>
              </td>
              <td>{{ reasonLabel(row.reason) || '—' }}</td>
              <td>{{ clientLabel(row.client) }}</td>
              <td>{{ row.ipAddress ?? '—' }}</td>
              <td class="user-agent">{{ row.userAgent ?? '—' }}</td>
            </tr>
          }
        </tbody>
      </nz-table>

      @if (totalElements > pageSize) {
        <nz-pagination
          class="pagination"
          [nzPageIndex]="page"
          [nzPageSize]="pageSize"
          [nzTotal]="totalElements"
          (nzPageIndexChange)="changePage($event)"
        ></nz-pagination>
      }
    </nz-card>
  </section>
</main>
